import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
import NoPage from "./pages/NoPage";
import EventSearch from "./pages/event-search";
import Event from "./pages/event";
import EventDetails from "./pages/event-details";
import EventNews from "./pages/blog";
import Bloglist from "./pages/blog-list";
import BlogDetails from "./pages/blog-details";
import Contact from "./pages/contact";
import PromoCodes from "./pages/promo-codes";
import TermsConditions from "./pages/terms";
import TicketMaster from "./pages/API";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="*" element={<NoPage />} />
        <Route path="event-search" element={<EventSearch />} />
         <Route path="event-details/:slug" element={<EventDetails />} />
         <Route path="event" element={<Event />} />
          <Route path="/event-news" element={<EventNews />} />
          <Route path="/event-news/:slug" element={<EventNews />} />
         <Route path="blog-list" element={<Bloglist />} />
         <Route path="event-news-details/:slug" element={<BlogDetails />} />
         <Route path="contact" element={<Contact />} />
         <Route path="promo-codes" element={<PromoCodes />} />
         <Route path="terms-and-conditions" element={<TermsConditions />} />
         <Route path="ticketmaster-api" element={<TicketMaster />} />
      </Routes>
    </BrowserRouter>
  );
}
